import { defineMessages } from 'react-intl';

// The Property Move-In Date correction (household-mi-mo-date-changes, ENG-33618). The rows it
// shares with the Move-In and Move-Out lists (certification titles, chips) use the
// EditMoveDateModal impactMessages.
const messages = defineMessages({
  currentDate: {
    id: 'App.EditPropertyMoveInDateModal.CurrentDate',
    defaultMessage: 'Current: {date}',
  },
  reviewBanner: {
    id: 'App.EditPropertyMoveInDateModal.Impacts.ReviewBanner',
    defaultMessage:
      'Changing the Property Move-In Date will update the records below. Review them before saving.',
  },
  // A completed cert whose form prints the Property Move-In Date.
  needsReviewDescription: {
    id: 'App.EditPropertyMoveInDateModal.Impacts.NeedsReviewDescription',
    defaultMessage:
      'Property Move-In Date changed. Review and regenerate form {formName}.',
  },
  // An open cert whose generated form prints the Property Move-In Date: the form is voided.
  regenerateFormDescription: {
    id: 'App.EditPropertyMoveInDateModal.Impacts.RegenerateFormDescription',
    defaultMessage:
      'Property Move-In Date changed. Regenerate form {formName} before completing the certification.',
  },
});

export default messages;
